import useGetMockupOffer from './useGetMockupOffer'

export default useGetMockupOffer
